import { render, staticRenderFns } from "./OffShelf.vue?vue&type=template&id=faf414da&scoped=true"
import script from "./OffShelf.vue?vue&type=script&lang=js"
export * from "./OffShelf.vue?vue&type=script&lang=js"
import style0 from "./OffShelf.vue?vue&type=style&index=0&id=faf414da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf414da",
  null
  
)

export default component.exports